import { render, staticRenderFns } from "./BrandsByOfficeBarChart.vue?vue&type=template&id=5122cb20&scoped=true&"
import script from "./BrandsByOfficeBarChart.vue?vue&type=script&lang=ts&"
export * from "./BrandsByOfficeBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5122cb20",
  null
  
)

export default component.exports